import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    schedules: [],
    schedulers: [],
    total: 0,
    yearWeeks: [],
  },
  getters: {
    schedules: state => state.schedules,
    schedulers: state => state.schedulers,
    total: state => state.total,
    yearWeeks: state => state.yearWeeks,
  },
  mutations: {
    SET_SCHEDULES: (state, schedules) => { state.schedules = schedules },
    SET_SCHEDULERS: (state, schedulers) => { state.schedulers = schedulers },
    SET_TOTAL: (state, total) => { state.total = total },
    SET_YEAR_WEEK: (state, yearWeeks) => {
      state.yearWeeks = yearWeeks
    },
  },

  actions: {

    async getSchedules({ commit }, params) {
      try {
        const response = await axios.post('uni/schedules', params)
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          const { total } = data.data
          commit('SET_SCHEDULES', records)
          commit('SET_TOTAL', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async getSchedulersV3({ commit }, params) {
      try {
        const response = await axios.get('main-hgi/schedules/getSchedulesV3', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          const { total } = data.data
          commit('SET_SCHEDULERS', records)
          commit('SET_TOTAL', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async getSchedulers({ commit }, params) {
      try {
        const response = await axios.get('uni/schedules', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          const { total } = data.data
          commit('SET_SCHEDULERS', records)
          commit('SET_TOTAL', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async getYearWeek({ commit }, params) {
      try {
        const response = await axios.get('main-hgi/schedules/get_week', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS && Array.isArray(data.data)) {
          const weeksFormat = data.data.map(item => ({
            id: item.id,
            startDate: item.startDate,
            endDate: item.endDate,
            weekId: item.weekId,
            yearId: item.yearId,
            code: item.code,
          }))
          commit('SET_YEAR_WEEK', weeksFormat)
        } else {
        }
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
